document.addEventListener("DOMContentLoaded", function () {

  /* ==========================================
     CONFIGURATION
  ========================================== */

  const SHOP_DOMAIN = "nxtasia.myshopify.com";
  const STOREFRONT_TOKEN = "66c8e65de5b6f3bd03971b69e0ded99a";
  const API_VERSION = "2026-07";

  /*
    Number of results displayed inside
    the predictive-search dropdown.
  */
  const MAX_VISIBLE_RESULTS = 8;

  /*
    Number of candidate results requested
    from Shopify for predictive search.

    This is intentionally higher than the
    number displayed so we can filter and rank
    the results before showing the best ones.
  */
  const API_RESULT_LIMIT = 50;

  /*
    Do not run predictive search until the
    visitor has typed at least this many
    characters.
  */
  const MINIMUM_CHARACTERS = 2;

  /*
    Wait this long after the visitor stops
    typing before sending the API request.
  */
  const DEBOUNCE_DELAY = 300;

  /* ==========================================
   SEARCH TERMINOLOGY ALIASES
========================================== */

/*
  IMPORTANT:

  Keep this list identical to
  SEARCH_TERM_GROUPS in custom-search.js.

  Terms within each group are treated as
  equivalent search forms.
*/

/* ==========================================
   SHARED SEARCH TERMINOLOGY ALIASES
========================================== */

const SEARCH_TERM_GROUPS =
  (
    window.NXTSearchConfig &&
    Array.isArray(
      window.NXTSearchConfig.termGroups
    )
  )
    ? window.NXTSearchConfig.termGroups
    : [];

    /* ==========================================
   SHARED SEARCH STOP WORDS
========================================== */

const SEARCH_STOP_WORDS =
  (
    window.NXTSearchConfig &&
    Array.isArray(
      window.NXTSearchConfig.stopWords
    )
  )
    ? window.NXTSearchConfig.stopWords
    : [];


    /* ==========================================
   SHARED FUZZY SEARCH VOCABULARY
========================================== */

const BASE_FUZZY_VOCABULARY =
  Array.isArray(
    window.NXTSearchVocabulary
  )
    ? window.NXTSearchVocabulary
    : [];


const SEARCH_STOP_WORD_SET =
  new Set(
    SEARCH_STOP_WORDS.map(
      function (word) {

        return String(word)
          .trim()
          .toLowerCase();

      }
    )
  );



/*
  Predictive search deliberately uses a
  smaller retrieval budget than the full
  search page.
*/

const MAX_PREDICTIVE_VARIANTS = 8;


  const endpoint =
    `https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`;


  /* ==========================================
     ELEMENTS
  ========================================== */

  const wrapper =
    document.querySelector(
      ".predictive-search-wrapper"
    );


  const form =
    wrapper
      ? wrapper.querySelector(
          ".search-bar"
        )
      : null;


  const input =
    wrapper
      ? wrapper.querySelector(
          ".search-bar__input"
        )
      : null;


  const dropdown =
    document.getElementById(
      "predictive-search-results"
    );


  /*
    Stop safely if the predictive-search
    markup is not present on the page.
  */
  if (
    !wrapper ||
    !form ||
    !input ||
    !dropdown
  ) {

    return;

  }


  /* ==========================================
     STATE
  ========================================== */

  let debounceTimer = null;
  let requestController = null;
  let activeIndex = -1;
  let currentResults = [];


  /* ==========================================
     NORMALIZE TECHNICAL SEARCH TERMS
  ========================================== */

  function normalizeSearchQuery(query) {

    let normalized =
      String(query || "").trim();


    /*
      Frequency

      400hz
      400Hz
      400 hz

      become:

      400 hz
    */

    normalized = normalized.replace(
      /(\d+)\s*hz\b/gi,
      "$1 hz"
    );


    /*
      Voltage

      28v -> 28 v

      Part numbers such as A400 are not
      affected by this rule.
    */

    normalized = normalized.replace(
      /(\d+)\s*kv\b/gi,
      "$1 kv"
    );

    normalized = normalized.replace(
      /(\d+)\s*v\b/gi,
      "$1 v"
    );


    /*
      Current

      750a -> 750 a
    */

    normalized = normalized.replace(
      /(\d+)\s*ka\b/gi,
      "$1 ka"
    );

    normalized = normalized.replace(
      /(\d+)\s*a\b/gi,
      "$1 a"
    );


    /*
      Power
    */

    normalized = normalized.replace(
      /(\d+)\s*kva\b/gi,
      "$1 kva"
    );

    normalized = normalized.replace(
      /(\d+)\s*kw\b/gi,
      "$1 kw"
    );


    /*
      Cable cross-sectional area
    */

    normalized = normalized.replace(
      /(\d+)\s*mm2\b/gi,
      "$1 mm2"
    );

    normalized = normalized.replace(
      /(\d+)\s*mm²/gi,
      "$1 mm²"
    );


    /*
      Remove accidental multiple spaces.
    */

    normalized = normalized.replace(
      /\s+/g,
      " "
    );


    return normalized.trim();
  }


  /* ==========================================
     NORMALIZE TEXT FOR MATCHING
  ========================================== */

  function normalizeForMatching(text) {

    return normalizeSearchQuery(
      String(text || "")
        .replace(/\u00A0/g, " ")
        .replace(/\s+/g, " ")
        .trim()
    ).toLowerCase();

  }


  /* ==========================================
     GRAPHQL QUERY
  ========================================== */

  const SEARCH_QUERY = `
    query PredictiveSearch(
      $query: String!,
      $first: Int!
    ) {

      search(
        query: $query,
        first: $first,
        types: [ARTICLE, PAGE, PRODUCT],
        sortKey: RELEVANCE,
        prefix: LAST
      ) {

        totalCount

        edges {

          node {

            __typename

            ... on Article {
              id
              title
              content
              excerpt
              onlineStoreUrl

              image {
                url
                altText
              }
            }

            ... on Page {
              id
              title
              body
              onlineStoreUrl
            }

            ... on Product {
              id
              title
              description
              onlineStoreUrl

              featuredImage {
                url
                altText
              }
            }

          }

        }

      }

    }
  `;


  /* ==========================================
     GET RESULT BODY
  ========================================== */

  function getItemBody(item) {

    if (
      item.__typename ===
      "Article"
    ) {

      return item.content || "";

    }


    if (
      item.__typename ===
      "Page"
    ) {

      return item.body || "";

    }


    if (
      item.__typename ===
      "Product"
    ) {

      return item.description || "";

    }


    return "";
  }


  /* ==========================================
     GET RESULT IMAGE
  ========================================== */

  function getItemImage(item) {

    if (
      item.__typename === "Article" &&
      item.image
    ) {

      return item.image;

    }


    if (
      item.__typename === "Product" &&
      item.featuredImage
    ) {

      return item.featuredImage;

    }


    return null;
  }


  /* ==========================================
     ESCAPE HTML
  ========================================== */

  function escapeHtml(value) {

    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  /* ==========================================
     ESCAPE REGEX
  ========================================== */

  function escapeRegExp(value) {

    return String(value)
      .replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&"
      );
  }


  /* ==========================================
   SAFE SEARCH TERM MATCHING
========================================== */

function containsSearchTerm(
  text,
  term
) {

  const source =
    String(text || "")
      .toLowerCase();


  const target =
    String(term || "")
      .trim()
      .toLowerCase();


  if (!target) {
    return false;
  }


  const escaped =
    escapeRegExp(
      target
    );


  const regex =
    new RegExp(
      `(^|[^a-z0-9])${escaped}(?=$|[^a-z0-9])`,
      "i"
    );


  return regex.test(
    source
  );
}

  /* ==========================================
   NUMERIC UNIT VARIANTS
========================================== */

function getNumericUnitVariants(term) {

  const value =
    String(term || "").trim();


  let match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:a|amp|amps|ampere|amperes)$/i
    );


  if (match) {

    const number = match[1];

    return [
      `${number}A`,
      `${number} A`,
      `${number} amp`,
      `${number} amps`,
      `${number} ampere`,
      `${number} amperes`
    ];

  }


  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:v|volt|volts)$/i
    );


  if (match) {

    const number = match[1];

    return [
      `${number}V`,
      `${number} V`,
      `${number} volt`,
      `${number} volts`
    ];

  }


  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:hz|hertz)$/i
    );


  if (match) {

    const number = match[1];

    return [
      `${number}Hz`,
      `${number} Hz`,
      `${number} hertz`
    ];

  }


  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:mm²|mm2|mmsq)$/i
    );


  if (match) {

    const number = match[1];

    return [
      `${number}mm²`,
      `${number} mm²`,
      `${number}mm2`,
      `${number} mm2`,
      `${number}mmsq`,
      `${number} mmsq`
    ];

  }


  return [];
}

/* ==========================================
   SINGULAR / PLURAL WORD VARIANTS
========================================== */

/*
  Generate conservative singular/plural forms
  for ordinary alphabetic search words.

  Examples:

  panel      <-> panels
  socket     <-> sockets
  connector  <-> connectors
  box        <-> boxes
  switch     <-> switches
  battery    <-> batteries

  Technical identifiers are deliberately
  excluded:

  32A
  IP67
  BC1
  SPX4PD1BR
  415V
*/

function getWordFormVariants(term) {

  const original =
    String(term || "").trim();


  if (!original) {
    return [];
  }


  /*
    Only process ONE ordinary alphabetic word.

    Anything containing numbers, hyphens,
    spaces or symbols is left untouched.
  */

  if (
    !/^[a-z]+$/i.test(original)
  ) {

    return [
      original
    ];

  }


  /*
    Very short words are too ambiguous for
    automatic grammatical transformation.
  */

  if (
    original.length < 4
  ) {

    return [
      original
    ];

  }


  const lower =
    original.toLowerCase();


  const variants =
    new Set([
      original
    ]);


  /* ========================================
     PLURAL -> SINGULAR
  ======================================== */

  /*
    batteries -> battery
    categories -> category
  */

  if (
    /^[a-z]{3,}ies$/i.test(original)
  ) {

    variants.add(
      original.slice(0, -3) +
      "y"
    );


    return Array.from(variants);

  }


  /*
    boxes    -> box
    switches -> switch
    classes  -> class
  */

  if (
    /(?:ches|shes|xes|zes|sses)$/i.test(
      original
    )
  ) {

    variants.add(
      original.slice(0, -2)
    );


    return Array.from(variants);

  }


  /*
    panels     -> panel
    sockets    -> socket
    connectors -> connector
  */

  if (
    lower.endsWith("s") &&
    !lower.endsWith("ss") &&
    !lower.endsWith("us") &&
    !lower.endsWith("is")
  ) {

    variants.add(
      original.slice(0, -1)
    );


    return Array.from(variants);

  }


  /* ========================================
     SINGULAR -> PLURAL
  ======================================== */

  /*
    battery -> batteries

    But:
    relay -> relays
  */

  if (
    /[^aeiou]y$/i.test(
      original
    )
  ) {

    variants.add(
      original.slice(0, -1) +
      "ies"
    );


    return Array.from(variants);

  }


  /*
    box    -> boxes
    switch -> switches
    class  -> classes
  */

  if (
    /(?:ch|sh|x|z|ss)$/i.test(
      original
    )
  ) {

    variants.add(
      original + "es"
    );


    return Array.from(variants);

  }


  /*
    Regular plural.
  */

  variants.add(
    original + "s"
  );


  return Array.from(variants);
}


/* ==========================================
   FUZZY SEARCH ELIGIBILITY
========================================== */

function isFuzzyEligibleTerm(term) {

  const value =
    String(term || "")
      .trim()
      .toLowerCase();


  /*
    Minimum length.

    Short words are too ambiguous for safe
    automatic fuzzy matching.
  */

  if (
    value.length < 5
  ) {

    return false;

  }


  /*
    CRITICAL SAFETY RULE:

    Fuzzy matching is permitted only for
    ordinary alphabetic words.

    Therefore all of these are excluded:

    32A
    415V
    IP67
    IK10
    BC1-3403
    model numbers
    hyphenated technical identifiers
  */

  if (
    !/^[a-z]+$/.test(value)
  ) {

    return false;

  }


  /*
    Stop words are never fuzzy targets.
  */

  if (
    SEARCH_STOP_WORD_SET.has(
      value
    )
  ) {

    return false;

  }


  return true;
}


/* ==========================================
   BUILD EFFECTIVE FUZZY VOCABULARY
========================================== */

function buildEffectiveFuzzyVocabulary() {

  const vocabulary =
    new Set();


  /* ========================================
     TITLE-DERIVED VOCABULARY
  ======================================== */

  BASE_FUZZY_VOCABULARY.forEach(
    function (term) {

      const value =
        String(term || "")
          .trim()
          .toLowerCase();


      if (
        isFuzzyEligibleTerm(
          value
        )
      ) {

        vocabulary.add(
          value
        );

      }

    }
  );


  /* ========================================
     TRUSTED SEARCH TERM GROUPS
  ======================================== */

  /*
    Automatically incorporate eligible
    SINGLE-WORD aliases.

    Therefore future additions such as:

    busbar

    automatically become fuzzy-searchable
    without editing search-vocabulary.js.
  */

  SEARCH_TERM_GROUPS.forEach(
    function (group) {

      group.forEach(
        function (term) {

          const value =
            String(term || "")
              .trim()
              .toLowerCase();


          if (
            isFuzzyEligibleTerm(
              value
            )
          ) {

            vocabulary.add(
              value
            );

          }

        }
      );

    }
  );


  return Array.from(vocabulary)
    .sort();
}


const FUZZY_VOCABULARY =
  buildEffectiveFuzzyVocabulary();


  /* ==========================================
   DAMERAU-LEVENSHTEIN DISTANCE
========================================== */

/*
  Measures typing distance between two words.

  Supports:

  - insertion
  - deletion
  - substitution
  - adjacent transposition

  The transposition support is useful for
  common typing mistakes such as:

  panle -> panel
*/

function damerauLevenshtein(
  source,
  target
) {

  const a =
    String(source || "")
      .toLowerCase();

  const b =
    String(target || "")
      .toLowerCase();


  const rows =
    a.length + 1;

  const columns =
    b.length + 1;


  const matrix =
    Array.from(
      {
        length:
          rows
      },
      function () {

        return new Array(
          columns
        ).fill(0);

      }
    );


  for (
    let i = 0;
    i < rows;
    i += 1
  ) {

    matrix[i][0] = i;

  }


  for (
    let j = 0;
    j < columns;
    j += 1
  ) {

    matrix[0][j] = j;

  }


  for (
    let i = 1;
    i < rows;
    i += 1
  ) {

    for (
      let j = 1;
      j < columns;
      j += 1
    ) {

      const substitutionCost =
        a[i - 1] ===
        b[j - 1]
          ? 0
          : 1;


      matrix[i][j] =
        Math.min(

          /*
            Deletion
          */

          matrix[i - 1][j] + 1,


          /*
            Insertion
          */

          matrix[i][j - 1] + 1,


          /*
            Substitution
          */

          matrix[i - 1][j - 1] +
            substitutionCost

        );


      /*
        Adjacent transposition.

        Example:

        panle
        panel
      */

      if (
        i > 1 &&
        j > 1 &&
        a[i - 1] ===
          b[j - 2] &&
        a[i - 2] ===
          b[j - 1]
      ) {

        matrix[i][j] =
          Math.min(
            matrix[i][j],

            matrix[i - 2][j - 2] +
              substitutionCost
          );

      }

    }

  }


  return matrix[
    a.length
  ][
    b.length
  ];
}


/* ==========================================
   FUZZY DISTANCE LIMIT
========================================== */

function getMaximumFuzzyDistance(
  term
) {

  const length =
    String(term || "").length;


  /*
    Under 5 characters:
    fuzzy matching disabled completely.
  */

  if (
    length < 5
  ) {

    return 0;

  }


  /*
    5-7 characters:
    allow only ONE edit.
  */

  if (
    length <= 7
  ) {

    return 1;

  }


  /*
    8-11 characters:
    allow up to TWO edits.
  */

  if (
    length <= 11
  ) {

    return 2;

  }


  /*
    Longer words can tolerate up to
    THREE edits while remaining relatively
    distinctive.
  */

  return 3;
}


/* ==========================================
   FIND FUZZY VOCABULARY MATCH
========================================== */

function findFuzzyVocabularyMatch(
  term
) {

  const input =
    String(term || "")
      .trim()
      .toLowerCase();


  if (
    !isFuzzyEligibleTerm(
      input
    )
  ) {

    return null;

  }


  /*
    If the term is already correctly present
    in our trusted vocabulary, there is
    nothing to correct.
  */

  if (
    FUZZY_VOCABULARY.includes(
      input
    )
  ) {

    return null;

  }


  const maximumDistance =
    getMaximumFuzzyDistance(
      input
    );


  if (
    maximumDistance === 0
  ) {

    return null;

  }


  const candidates = [];


  FUZZY_VOCABULARY.forEach(
    function (candidate) {

      /*
        Cheap length filter before calculating
        the full edit distance.
      */

      if (
        Math.abs(
          candidate.length -
          input.length
        ) >
        maximumDistance
      ) {

        return;

      }


      const distance =
        damerauLevenshtein(
          input,
          candidate
        );


      if (
        distance <=
        maximumDistance
      ) {

        candidates.push({

          term:
            candidate,

          distance:
            distance

        });

      }

    }
  );


  if (
    candidates.length === 0
  ) {

    return null;

  }


  candidates.sort(
    function (a, b) {

      /*
        Lowest edit distance wins.
      */

      if (
        a.distance !==
        b.distance
      ) {

        return (
          a.distance -
          b.distance
        );

      }


      /*
        If edit distance ties, prefer the
        candidate closest in length.
      */

      const aLengthDifference =
        Math.abs(
          a.term.length -
          input.length
        );


      const bLengthDifference =
        Math.abs(
          b.term.length -
          input.length
        );


      if (
        aLengthDifference !==
        bLengthDifference
      ) {

        return (
          aLengthDifference -
          bLengthDifference
        );

      }


      return a.term.localeCompare(
        b.term
      );

    }
  );


  const best =
    candidates[0];


  const secondBest =
    candidates.length > 1
      ? candidates[1]
      : null;


  /*
    AMBIGUITY GUARD

    If two DIFFERENT vocabulary words are
    equally good fuzzy candidates, don't
    guess.

    Example:

    candidate A distance 1
    candidate B distance 1

    -> leave the customer's term untouched.
  */

  if (
    secondBest &&
    secondBest.distance ===
      best.distance
  ) {

    return null;

  }


  return best;
}





/* ==========================================
   CANONICAL NUMERIC UNIT FORM
========================================== */

function getCanonicalNumericUnit(term) {

  const value =
    String(term || "").trim();


  /*
    AMPERE

    32A
    32 amps
    32 ampere

    become:

    32 A
  */

  let match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:a|amp|amps|ampere|amperes)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} A`,
      compact: `${match[1]}A`
    };

  }


  /*
    VOLTAGE
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:v|volt|volts)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} V`,
      compact: `${match[1]}V`
    };

  }


  /*
    FREQUENCY
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:hz|hertz)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} Hz`,
      compact: `${match[1]}Hz`
    };

  }


  /*
    CABLE CROSS-SECTIONAL AREA
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:mm²|mm2|mmsq)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} mm²`,
      compact: `${match[1]}mm²`
    };

  }


  return null;
}





/* ==========================================
   BUILD COMPREHENSIVE MATCH VARIANTS
========================================== */

function getSearchQueryVariants(query) {

  const original =
    String(query || "")
      .trim()
      .replace(/\s+/g, " ");


  if (!original) {
    return [];
  }


  const variants =
    new Set([
      original
    ]);


  /*
    Terminology aliases.
  */

SEARCH_TERM_GROUPS.forEach(
  function (group) {

    /*
      Check longer aliases first.
    */

    const sortedGroup =
      group
        .slice()
        .sort(
          function (a, b) {

            return b.length - a.length;

          }
        );


    /*
      Only recognise aliases as complete
      alphanumeric terms.

      This prevents:

      ss -> Stainless
      ss -> SSFCTB...
    */

    const matchingAlias =
      sortedGroup.find(
        function (alias) {

          return containsSearchTerm(
            original,
            alias
          );

        }
      );


    if (!matchingAlias) {
      return;
    }


    /*
      Replace the detected alias with every
      equivalent form in its group.
    */

    sortedGroup.forEach(
      function (replacement) {

        const regex =
          new RegExp(
            `(^|[^a-z0-9])(${escapeRegExp(
              matchingAlias
            )})(?=$|[^a-z0-9])`,
            "gi"
          );


        const expandedVariant =
          original.replace(
            regex,
            function (
              match,
              prefix
            ) {

              return (
                prefix +
                replacement
              );

            }
          );


        variants.add(
          expandedVariant
        );

      }
    );

  }
);


  /*
    Numeric units.
  */

  const unitRegex =
    /(\d+(?:\.\d+)?)\s*(a|amp|amps|ampere|amperes|v|volt|volts|hz|hertz|mm²|mm2|mmsq)\b/gi;


  Array.from(
    original.matchAll(
      unitRegex
    )
  ).forEach(
    function (unitMatch) {

      const matchedUnit =
        unitMatch[0];


      getNumericUnitVariants(
        matchedUnit
      ).forEach(
        function (replacement) {

          variants.add(
            original.replace(
              matchedUnit,
              replacement
            )
          );

        }
      );

    }
  );


  Array.from(variants)
    .forEach(
      function (variant) {

        variants.add(
          normalizeSearchQuery(
            variant
          )
        );

      }
    );


  return Array.from(variants)
    .filter(Boolean);
}


/* ==========================================
   EXPAND COMBINED MATCH VARIANTS
========================================== */

function expandSearchQueryVariants(query) {

  const variants =
    new Set([
      String(query || "")
        .trim()
        .replace(/\s+/g, " ")
    ]);


  /*
    Repeated passes allow combinations such as:

    singlepole connector 32 amps

    -> single pole connector 32A
  */

  for (
    let pass = 0;
    pass < 3;
    pass += 1
  ) {

    const currentVariants =
      Array.from(variants);


    currentVariants.forEach(
      function (variant) {

        getSearchQueryVariants(
          variant
        ).forEach(
          function (expanded) {

            variants.add(
              expanded
            );

          }
        );

      }
    );

  }


  return Array.from(variants)
    .filter(Boolean)
    .slice(0, 30);
}

/* ==========================================
   BUILD PREDICTIVE SEARCH CONCEPTS
========================================== */

/*
  Break a multi-term query into concepts that
  must ALL occur in the same result.

  Examples:

  32a panel
  ->
  [32a] AND [panel]

  shore power connector
  ->
  [shore power] AND [connector]

  single pole 500a
  ->
  [single pole] AND [500a]
*/

function buildSearchConcepts(query) {

  const original =
    String(query || "")
      .trim()
      .replace(/\s+/g, " ");


  if (!original) {
    return [];
  }


  let workingQuery =
    original;


  const protectedConcepts = [];


  /* ========================================
     PROTECT MULTI-WORD TERMINOLOGY ALIASES
  ======================================== */

  SEARCH_TERM_GROUPS.forEach(
    function (group) {

      const sortedGroup =
        group
          .slice()
          .sort(function (a, b) {

            return b.length - a.length;

          });


      sortedGroup.forEach(
        function (alias) {

          if (
            !alias.includes(" ")
          ) {

            return;

          }


          const regex =
            new RegExp(
              escapeRegExp(alias),
              "i"
            );


          const match =
            workingQuery.match(
              regex
            );


          if (!match) {
            return;
          }


          const placeholder =
            `__SEARCH_CONCEPT_${protectedConcepts.length}__`;


          protectedConcepts.push(
            match[0]
          );


          workingQuery =
            workingQuery.replace(
              regex,
              placeholder
            );

        }
      );

    }
  );


  /* ========================================
     PROTECT NUMBER + UNIT PHRASES
  ======================================== */

  const numericUnitRegex =
    /\d+(?:\.\d+)?\s+(?:amp|amps|ampere|amperes|volt|volts|hz|hertz|mm²|mm2|mmsq)\b/gi;


  workingQuery =
    workingQuery.replace(
      numericUnitRegex,
      function (match) {

        const placeholder =
          `__SEARCH_CONCEPT_${protectedConcepts.length}__`;


        protectedConcepts.push(
          match
        );


        return placeholder;

      }
    );


  /* ========================================
     SPLIT EVERYTHING ELSE
  ======================================== */

  const rawConcepts =
    workingQuery
      .split(/\s+/)
      .filter(Boolean);


  const concepts =
    rawConcepts.map(
      function (concept) {

        const placeholderMatch =
          concept.match(
            /^__SEARCH_CONCEPT_(\d+)__$/
          );


        if (placeholderMatch) {

          return protectedConcepts[
            Number(
              placeholderMatch[1]
            )
          ];

        }


        return concept;

      }
    );


  /*
    Remove duplicate concepts.
  */

/* ========================================
   DEDUPLICATE PARSED CONCEPTS
======================================== */

const uniqueConcepts = [];
const seenConcepts =
  new Set();


concepts.forEach(
  function (concept) {

    const cleaned =
      String(concept || "")
        .trim();


    if (!cleaned) {
      return;
    }


    const key =
      normalizeForMatching(
        cleaned
      );


    if (
      seenConcepts.has(key)
    ) {

      return;

    }


    seenConcepts.add(key);

    uniqueConcepts.push(
      cleaned
    );

  }
);


/* ========================================
   REMOVE STANDALONE STOP WORDS
======================================== */

/*
  Stop words are checked against COMPLETE
  concepts only.

  Therefore:

  "for"         -> ignored
  "form"        -> retained
  "transformer" -> retained
  "cee form"    -> retained
  "32A"         -> retained
*/

const meaningfulConcepts =
  uniqueConcepts.filter(
    function (concept) {

      const key =
        normalizeForMatching(
          concept
        );


      return !SEARCH_STOP_WORD_SET.has(
        key
      );

    }
  );


/* ========================================
   ALL-STOP-WORD SAFETY FALLBACK
======================================== */

/*
  Normal example:

  32a socket for panel

  becomes:

  [32a, socket, panel]


  Edge case:

  for the

  would otherwise become an empty concept
  list, so preserve the original concepts.
*/

if (
  meaningfulConcepts.length > 0
) {

  return meaningfulConcepts;

}


return uniqueConcepts;
}


/* ==========================================
   GET MATCH VARIANTS FOR ONE CONCEPT
========================================== */

function getConceptMatchVariants(concept) {

  const variants =
    new Set();


  /*
    Existing search intelligence first:

    terminology aliases
    technical units
    normalization
  */

  expandSearchQueryVariants(
    concept
  ).forEach(
    function (variant) {

      variants.add(
        variant
      );

    }
  );


  /*
    Add singular/plural forms for ordinary
    one-word concepts.

    Example:

    panels
      ->
    panels
    panel
  */

  Array.from(variants)
    .forEach(
      function (variant) {

        getWordFormVariants(
          variant
        ).forEach(
          function (wordForm) {

            variants.add(
              wordForm
            );

          }
        );

      }
    );

    /* ========================================
   FUZZY TYPO VARIANTS
======================================== */

Array.from(variants)
  .forEach(
    function (variant) {

      const fuzzyMatch =
        findFuzzyVocabularyMatch(
          variant
        );


      if (
        !fuzzyMatch ||
        !fuzzyMatch.term
      ) {

        return;

      }


      /*
        Preserve the customer's original term
        and add the high-confidence corrected
        vocabulary term as another variant.
      */

      variants.add(
        fuzzyMatch.term
      );


      /*
        Let the corrected term participate in
        singular/plural matching too.

        conector
          ->
        connector
          ->
        connector / connectors
      */

      getWordFormVariants(
        fuzzyMatch.term
      ).forEach(
        function (wordForm) {

          variants.add(
            wordForm
          );

        }
      );

    }
  );


  /*
    Normalize everything for local matching.
  */

  return Array.from(
    new Set(
      Array.from(variants).map(
        function (variant) {

          return normalizeForMatching(
            variant
          );

        }
      )
    )
  )
    .filter(Boolean)
    .sort(function (a, b) {

      return b.length - a.length;

    });
}


/* ==========================================
   LIGHTWEIGHT PREDICTIVE RETRIEVAL VARIANTS
========================================== */

function getPredictiveRetrievalVariants(query) {

  const original =
    String(query || "")
      .trim()
      .replace(/\s+/g, " ");


  if (!original) {
    return [];
  }


  const variants =
    new Set([
      original
    ]);


  /* ========================================
     TERMINOLOGY
  ======================================== */

  SEARCH_TERM_GROUPS.forEach(
    function (group) {

      const sortedGroup =
        group
          .slice()
          .sort(function (a, b) {

            return b.length - a.length;

          });


      const matchingAlias =
        sortedGroup.find(
          function (alias) {

            return original
              .toLowerCase()
              .includes(
                alias.toLowerCase()
              );

          }
        );


      if (!matchingAlias) {
        return;
      }


      /*
        Add equivalent terminology until the
        predictive retrieval budget is reached.
      */

      sortedGroup.forEach(
        function (replacement) {

          if (
            variants.size >=
            MAX_PREDICTIVE_VARIANTS
          ) {

            return;

          }


          const regex =
            new RegExp(
              escapeRegExp(
                matchingAlias
              ),
              "gi"
            );


          variants.add(
            original.replace(
              regex,
              replacement
            )
          );

        }
      );

    }
  );


  /* ========================================
     NUMERIC UNITS
  ======================================== */

  const unitRegex =
    /(\d+(?:\.\d+)?)\s*(a|amp|amps|ampere|amperes|v|volt|volts|hz|hertz|mm²|mm2|mmsq)\b/gi;


  const currentVariants =
    Array.from(variants);


  currentVariants.forEach(
    function (variant) {

      if (
        variants.size >=
        MAX_PREDICTIVE_VARIANTS
      ) {

        return;

      }


      const unitMatch =
        variant.match(
          unitRegex
        );


      if (!unitMatch) {
        return;
      }


      const matchedUnit =
        unitMatch[0];


      const canonical =
        getCanonicalNumericUnit(
          matchedUnit
        );


      if (!canonical) {
        return;
      }


      variants.add(
        variant.replace(
          matchedUnit,
          canonical.spaced
        )
      );


      if (
        variants.size <
        MAX_PREDICTIVE_VARIANTS
      ) {

        variants.add(
          variant.replace(
            matchedUnit,
            canonical.compact
          )
        );

      }

    }
  );


  /* ========================================
   SINGULAR / PLURAL RETRIEVAL FORMS
======================================== */

/*
  Include grammatical variants for simple
  one-word predictive queries.

  Examples:

  panel
  panels

  socket
  sockets

  Technical identifiers such as 32A and
  IP67 remain untouched.
*/

const grammaticalVariants =
  Array.from(variants);


grammaticalVariants.forEach(
  function (variant) {

    /*
      Respect the predictive API budget.
    */

    if (
      variants.size >=
      MAX_PREDICTIVE_VARIANTS
    ) {

      return;

    }


    getWordFormVariants(
      variant
    ).forEach(
      function (wordForm) {

        if (
          variants.size <
          MAX_PREDICTIVE_VARIANTS
        ) {

          variants.add(
            wordForm
          );

        }

      }
    );

  }
);


  /*
    Keep the predictive API workload small.
  */

  return Array.from(variants)
    .filter(Boolean)
    .slice(
      0,
      MAX_PREDICTIVE_VARIANTS
    );
}


/* ==========================================
   MULTI-CONCEPT PREDICTIVE RETRIEVAL
========================================== */

function getMultiConceptPredictiveVariants(
  query
) {

const variants =
  new Set();



  /*
  First expand the complete query.

  This preserves terminology groups spanning
  multiple parsed concepts.

  Example:

  stainless steel 316
      ->
  SS316
  SS 316
  316 stainless steel
*/

expandSearchQueryVariants(
  query
).forEach(
  function (variant) {

    variants.add(
      variant
    );


    variants.add(
      normalizeSearchQuery(
        variant
      )
    );

  }
);


/*
  Parse the query first so grammatical stop
  words can be excluded from API retrieval.
*/

const concepts =
  buildSearchConcepts(
    query
  );


const meaningfulQuery =
  concepts.join(" ");


/*
  Retrieve useful versions of the meaningful
  combined query.

  Example:

  Customer types:

  32a socket for panel

  Shopify receives the combined form:

  32a socket panel

  rather than requiring "for".
*/

getPredictiveRetrievalVariants(
  meaningfulQuery || query
).forEach(
  function (variant) {

    variants.add(
      variant
    );

  }
);


/* ========================================
   RETRIEVE EACH SEARCH CONCEPT
======================================== */

/*
  Use the SAME concept variants that our
  local matching engine already understands.

  This automatically includes:

  - terminology aliases
  - technical-unit variants
  - singular/plural forms
  - fuzzy spelling variants

  Example:

  conector

  concept variants:
  conector
  conectors
  connector
  connectors

  Shopify can therefore retrieve correctly
  spelled connector results even though the
  customer entered a typo.
*/

concepts.forEach(
  function (concept) {

    const conceptVariants =
      getConceptMatchVariants(
        concept
      );


    conceptVariants.forEach(
      function (conceptVariant) {

        if (
          variants.size >=
          MAX_PREDICTIVE_VARIANTS
        ) {

          return;

        }


        /*
          Feed each intelligent concept variant
          through the existing predictive
          retrieval optimizer as well.
        */

        getPredictiveRetrievalVariants(
          conceptVariant
        ).forEach(
          function (retrievalVariant) {

            if (
              variants.size <
              MAX_PREDICTIVE_VARIANTS
            ) {

              variants.add(
                retrievalVariant
              );

            }

          }
        );

      }
    );

  }
);


  return Array.from(variants)
    .filter(Boolean)
    .slice(
      0,
      MAX_PREDICTIVE_VARIANTS
    );
}


/* ==========================================
   ALIAS-AWARE HIGHLIGHTING
========================================== */

function highlightText(text, query) {

  const safeText =
    escapeHtml(text);


  const variants =
    new Set();


    /* ========================================
   COMPLETE QUERY HIGHLIGHT VARIANTS
======================================== */

/*
  Expand the complete query before splitting
  it into individual concepts.

  This allows specific multi-word terminology
  groups to participate in highlighting.

  Example:

  stainless steel 316
      ->
  ss316
  ss 316
  316 stainless steel
*/

expandSearchQueryVariants(
  query
).forEach(
  function (variant) {

    variants.add(
      variant
    );


    variants.add(
      normalizeSearchQuery(
        variant
      )
    );

  }
);

/*
  Highlight every search concept
  independently.

  Example:

  Query:
  32a panel

  Title:
  CEE Panel Mounted Socket 32A

  Both "Panel" and "32A" are highlighted.
*/

const concepts =
  buildSearchConcepts(
    query
  );


concepts.forEach(
  function (concept) {

    expandSearchQueryVariants(
      concept
    ).forEach(
      function (variant) {

        variants.add(
          variant
        );


        variants.add(
          normalizeSearchQuery(
            variant
          )
        );

      }
    );

  }
);


/*
  Add singular/plural forms for highlighting.

  Example:

  Customer searches:
  panels

  Result contains:
  Panel Mounted Socket

  "Panel" is still highlighted.
*/

Array.from(variants)
  .forEach(
    function (variant) {

      getWordFormVariants(
        variant
      ).forEach(
        function (wordForm) {

          variants.add(
            wordForm
          );

        }
      );

    }
  );


  /* ========================================
   FUZZY HIGHLIGHT VARIANTS
======================================== */

/*
  Customer:
  conector

  Result:
  Connector

  Highlight "Connector".
*/

Array.from(variants)
  .forEach(
    function (variant) {

      const fuzzyMatch =
        findFuzzyVocabularyMatch(
          variant
        );


      if (
        !fuzzyMatch ||
        !fuzzyMatch.term
      ) {

        return;

      }


      variants.add(
        fuzzyMatch.term
      );


      getWordFormVariants(
        fuzzyMatch.term
      ).forEach(
        function (wordForm) {

          variants.add(
            wordForm
          );

        }
      );

    }
  );



  /*
    Add compact technical forms.
  */

  Array.from(variants)
    .forEach(
      function (variant) {

        const compact =
          normalizeSearchQuery(
            variant
          )
            .replace(/(\d+)\s+(hz)\b/gi, "$1$2")
            .replace(/(\d+)\s+(kv)\b/gi, "$1$2")
            .replace(/(\d+)\s+(v)\b/gi, "$1$2")
            .replace(/(\d+)\s+(ka)\b/gi, "$1$2")
            .replace(/(\d+)\s+(a)\b/gi, "$1$2")
            .replace(/(\d+)\s+(kva)\b/gi, "$1$2")
            .replace(/(\d+)\s+(kw)\b/gi, "$1$2")
            .replace(/(\d+)\s+(mm2)\b/gi, "$1$2")
            .replace(/(\d+)\s+(mm²)/gi, "$1$2");


        variants.add(
          compact
        );

      }
    );


  const usableVariants =
    Array.from(variants)
      .filter(Boolean)
      .sort(function (a, b) {

        /*
          Longer aliases first.

          Example:
          hazardous area
          before
          hazardous
        */

        return b.length - a.length;

      });


  if (
    usableVariants.length === 0
  ) {

    return safeText;

  }


  const variantPattern =
    usableVariants
      .map(function (variant) {

        return escapeRegExp(
          escapeHtml(variant)
        );

      })
      .join("|");


  /*
    Keep your existing token-based highlighting
    behavior.

    This is the version we previously fixed so
    highlighting does not create visual spacing
    inside model numbers such as BCS-1504-7011.
  */

/*
  Process whitespace-separated display tokens
  so partially highlighted technical strings
  remain visually intact.
*/

const tokens =
  safeText.split(/(\s+)/);


/*
  Require alphanumeric boundaries around the
  complete search variant.

  Examples:

  Query equivalent: ss

  SS              -> match
  (SS)            -> match
  SSFCTB520x4.6   -> no match
  SS316           -> no generic "SS" match
  Stainless       -> no substring match

  But when SS316 itself is a variant:

  SS316           -> match
*/

const highlightRegex =
  new RegExp(
    `(^|[^a-z0-9])(${variantPattern})(?=$|[^a-z0-9])`,
    "gi"
  );


const testRegex =
  new RegExp(
    `(^|[^a-z0-9])(?:${variantPattern})(?=$|[^a-z0-9])`,
    "i"
  );


const highlightedTokens =
  tokens.map(
    function (token) {

      if (
        /^\s+$/.test(token)
      ) {

        return token;

      }


      if (
        !testRegex.test(token)
      ) {

        return token;

      }


      const highlightedToken =
        token.replace(
          highlightRegex,
          function (
            match,
            prefix,
            matchedText
          ) {

            return (
              prefix +
              '<strong class="highlight">' +
              matchedText +
              '</strong>'
            );

          }
        );


      return (
        '<span class="predictive-highlight-word">' +
        highlightedToken +
        '</span>'
      );

    }
  );


return highlightedTokens.join("");
}


/* ==========================================
   MULTI-CONCEPT PREDICTIVE RANKING
========================================== */

function prepareResults(
  items,
  query
) {

  const concepts =
    buildSearchConcepts(
      query
    );


  const conceptDefinitions =
    concepts.map(
      function (concept) {

        return {

          original:
            concept,

          normalized:
            normalizeForMatching(
              concept
            ),

          variants:
            getConceptMatchVariants(
              concept
            )

        };

      }
    );


  console.log(
    "Predictive search concepts:",
    conceptDefinitions
  );


  /* ========================================
     MATCH ONE CONCEPT
  ======================================== */

  function matchConcept(
    normalizedText,
    definition
  ) {

    /*
      Prefer the customer's exact form.
    */

    if (
      definition.normalized &&
      normalizedText.includes(
        definition.normalized
      )
    ) {

      return {
        matched: true,
        exact: true,
        variant:
          definition.normalized
      };

    }


    const matchedVariant =
      definition.variants.find(
        function (variant) {

          return normalizedText.includes(
            variant
          );

        }
      );


    if (matchedVariant) {

      return {
        matched: true,
        exact: false,
        variant:
          matchedVariant
      };

    }


    return {
      matched: false,
      exact: false,
      variant: null
    };
  }


  /* ========================================
     CLASSIFY EACH SHOPIFY RESULT
  ======================================== */

  const prepared =
    items.map(
      function (item) {

        const normalizedTitle =
          normalizeForMatching(
            item.title
          );


        const normalizedBody =
          normalizeForMatching(
            getItemBody(item)
          );


        const conceptMatches =
          conceptDefinitions.map(
            function (definition) {

              const titleResult =
                matchConcept(
                  normalizedTitle,
                  definition
                );


              const bodyResult =
                matchConcept(
                  normalizedBody,
                  definition
                );


              return {

                concept:
                  definition.original,

                matched:
                  titleResult.matched ||
                  bodyResult.matched,

                titleMatch:
                  titleResult.matched,

                bodyMatch:
                  bodyResult.matched,

                exactTitleMatch:
                  titleResult.matched &&
                  titleResult.exact,

                exactBodyMatch:
                  bodyResult.matched &&
                  bodyResult.exact,

                matchedTitleVariant:
                  titleResult.variant,

                matchedBodyVariant:
                  bodyResult.variant

              };

            }
          );


        /*
          UNIVERSAL AND RULE

          Every search concept must occur
          somewhere in this result.
        */

        const allConceptsMatch =
          conceptMatches.length > 0 &&
          conceptMatches.every(
            function (match) {

              return match.matched;

            }
          );


        const allConceptsInTitle =
          allConceptsMatch &&
          conceptMatches.every(
            function (match) {

              return match.titleMatch;

            }
          );


        const allConceptsExactInTitle =
          allConceptsMatch &&
          conceptMatches.every(
            function (match) {

              return match.exactTitleMatch;

            }
          );


        const titleConceptCount =
          conceptMatches.filter(
            function (match) {

              return match.titleMatch;

            }
          ).length;


        /*
          Preserve the properties expected by
          renderPredictiveResult().
        */

        const titleMatch =
          allConceptsMatch &&
          titleConceptCount > 0;


        const bodyMatch =
          allConceptsMatch &&
          conceptMatches.some(
            function (match) {

              return match.bodyMatch;

            }
          );


        /*
          RANKING

          1 = every concept exactly in title
          2 = every concept in title via exact/alias
          3 = some in title, remainder in body
          4 = all matched only through body
          5 = invalid
        */

        let priority = 5;


        if (
          allConceptsExactInTitle
        ) {

          priority = 1;

        } else if (
          allConceptsInTitle
        ) {

          priority = 2;

        } else if (
          allConceptsMatch &&
          titleConceptCount > 0
        ) {

          priority = 3;

        } else if (
          allConceptsMatch
        ) {

          priority = 4;

        }


        return {

          item:
            item,

          conceptMatches:
            conceptMatches,

          allConceptsMatch:
            allConceptsMatch,

          titleMatch:
            titleMatch,

          bodyMatch:
            bodyMatch,

          priority:
            priority

        };

      }
    );


  /*
    Reject candidates that don't satisfy
    EVERY concept.
  */

  const relevant =
    prepared.filter(
      function (result) {

        return (
          result.allConceptsMatch
        );

      }
    );


  relevant.sort(
    function (a, b) {

      return (
        a.priority -
        b.priority
      );

    }
  );


  return relevant;
}


/* ==========================================
   ALIAS-AWARE PREDICTIVE API REQUEST
========================================== */

async function searchStore(query) {

  /*
    Cancel every request belonging to the
    previous predictive search.
  */

  if (requestController) {

    requestController.abort();

  }


  requestController =
    new AbortController();


  const signal =
    requestController.signal;


  /*
    Generate only a small number of useful
    Shopify retrieval queries.

    Predictive search intentionally does NOT
    perform exhaustive retrieval.
  */

const retrievalVariants =
  getMultiConceptPredictiveVariants(
    query
  );


  console.log(
    "Predictive retrieval variants:",
    retrievalVariants
  );


  /* ========================================
     FETCH ONE VARIANT
  ======================================== */

  async function fetchVariant(
    searchQuery
  ) {

    const response =
      await fetch(
        endpoint,
        {

          method: "POST",

          signal:
            signal,

          headers: {

            "Content-Type":
              "application/json",

            "X-Shopify-Storefront-Access-Token":
              STOREFRONT_TOKEN

          },

          body:
            JSON.stringify({

              query:
                SEARCH_QUERY,

              variables: {

                query:
                  searchQuery,

                first:
                  API_RESULT_LIMIT

              }

            })

        }
      );


    if (!response.ok) {

      throw new Error(
        `Search request failed: ${response.status}`
      );

    }


    const result =
      await response.json();


    if (result.errors) {

      console.error(
        "Predictive search GraphQL errors:",
        result.errors
      );


      throw new Error(
        "Shopify returned a predictive search error."
      );

    }


    const search =
      result.data.search;


    console.log(
      `Predictive variant "${searchQuery}":`,
      search.edges.length,
      "candidates"
    );


    return search.edges.map(
      function (edge) {

        return edge.node;

      }
    );
  }


  /* ========================================
     SEARCH VARIANTS CONCURRENTLY
  ======================================== */

  const resultGroups =
    await Promise.all(

      retrievalVariants.map(
        function (variant) {

          return fetchVariant(
            variant
          );

        }
      )

    );


  /* ========================================
     MERGE + DEDUPLICATE
  ======================================== */

  const uniqueItems = [];

  const seenIds =
    new Set();


  resultGroups
    .flat()
    .forEach(
      function (item) {

        if (
          !item ||
          !item.id
        ) {

          return;

        }


        if (
          seenIds.has(
            item.id
          )
        ) {

          return;

        }


        seenIds.add(
          item.id
        );


        uniqueItems.push(
          item
        );

      }
    );


  console.log(
    "Predictive unique candidates:",
    uniqueItems.length
  );


  /* ========================================
     LOCAL ALIAS MATCHING + RANKING
  ======================================== */

  const prepared =
    prepareResults(
      uniqueItems,
      query
    );


  console.log(
    "Predictive relevant results:",
    prepared.length
  );


  /*
    We intentionally do NOT claim that this
    number represents every possible result
    on the site.

    The predictive dropdown only retrieves
    enough candidates to generate useful
    suggestions.

    The full search page performs the
    comprehensive search.
  */

  return {

    totalCount:
      prepared.length,

    results:
      prepared

  };
}


  /* ==========================================
     END PART 1 OF 3
     PASTE PART 2 DIRECTLY BELOW THIS
  ========================================== */
    /* ==========================================
     OPEN DROPDOWN
  ========================================== */

  function openDropdown() {

    dropdown.hidden = false;


    input.setAttribute(
      "aria-expanded",
      "true"
    );

  }


  /* ==========================================
     CLOSE DROPDOWN
  ========================================== */

  function closeDropdown() {

    dropdown.hidden = true;


    input.setAttribute(
      "aria-expanded",
      "false"
    );


    /*
      Reset keyboard selection whenever
      the dropdown closes.
    */

    activeIndex = -1;

  }


  /* ==========================================
     LOADING STATE
  ========================================== */

  function renderLoading() {

    dropdown.innerHTML = `
      <div class="predictive-search-status">
        Searching...
      </div>
    `;


    openDropdown();

  }


  /* ==========================================
     NO RESULTS STATE
  ========================================== */

  function renderNoResults(query) {

    dropdown.innerHTML = `
      <div class="predictive-search-status">
        No results found for
        "<strong>${escapeHtml(query)}</strong>"
      </div>
    `;


    openDropdown();

  }


  /* ==========================================
     GET RESULT URL
  ========================================== */

  function getItemUrl(item) {

    return (
      item.onlineStoreUrl ||
      "#"
    );

  }


  /* ==========================================
     RENDER ONE PREDICTIVE RESULT
  ========================================== */

  function renderPredictiveResult(
    result,
    query,
    index
  ) {

    const item =
      result.item;


    const url =
      getItemUrl(item);


    const image =
      getItemImage(item);


    /*
      Highlight the query in the title
      when the title itself contains
      the matching term.
    */

    let titleHtml;


    if (result.titleMatch) {

      titleHtml =
        highlightText(
          item.title,
          query
        );

    } else {

      titleHtml =
        escapeHtml(
          item.title
        );

    }


    /*
      Build image markup when the result
      has an available image.
    */

    let imageHtml = "";


    if (image) {

      imageHtml = `
        <div class="predictive-search-image">

          <img
            src="${escapeHtml(image.url)}"
            alt="${escapeHtml(
              image.altText ||
              item.title ||
              ""
            )}"
            loading="lazy"
          >

        </div>
      `;

    }


    return `
      <a
        href="${escapeHtml(url)}"
        class="predictive-search-item"
        role="option"
        data-predictive-index="${index}"
        aria-selected="false"
      >

        <div class="predictive-search-item-content">

          <div class="predictive-search-title">
            ${titleHtml}
          </div>

        </div>

        ${imageHtml}

      </a>
    `;

  }


  /* ==========================================
     RENDER PREDICTIVE RESULTS
  ========================================== */

  function renderResults(
    query,
    results,
    totalCount
  ) {

    /*
      Display only the best few results
      inside the dropdown.

      The full search page remains available
      through the View All link.
    */

    currentResults =
      results.slice(
        0,
        MAX_VISIBLE_RESULTS
      );


    if (
      currentResults.length === 0
    ) {

      renderNoResults(query);

      return;

    }


    let html = `
      <div class="predictive-search-items">
    `;


    currentResults.forEach(
      function (result, index) {

        html +=
          renderPredictiveResult(
            result,
            query,
            index
          );

      }
    );


    html += `
      </div>
    `;


    /* ========================================
       VIEW ALL RESULTS LINK
    ======================================== */

    const fullSearchUrl =
      `/search?q=${encodeURIComponent(query)}`;


const viewAllText =
  `View all results for "${escapeHtml(query)}"`;


    html += `
      <a
        href="${fullSearchUrl}"
        class="predictive-search-view-all"
      >

        <span>
          ${viewAllText}
        </span>

        <span
          class="predictive-search-view-all-arrow"
          aria-hidden="true"
        >
          →
        </span>

      </a>
    `;


    dropdown.innerHTML =
      html;


    /*
      Nothing is keyboard-selected when
      a fresh result set first appears.
    */

    activeIndex = -1;


    openDropdown();

  }


  /* ==========================================
     UPDATE ACTIVE KEYBOARD RESULT
  ========================================== */

  function updateActiveResult() {

    const items =
      dropdown.querySelectorAll(
        ".predictive-search-item"
      );


    /*
      Remove the previous active state.
    */

    items.forEach(
      function (item) {

        item.classList.remove(
          "is-active"
        );


        item.setAttribute(
          "aria-selected",
          "false"
        );

      }
    );


    /*
      Nothing to activate.
    */

    if (
      activeIndex < 0 ||
      activeIndex >= items.length
    ) {

      return;

    }


    const activeItem =
      items[activeIndex];


    activeItem.classList.add(
      "is-active"
    );


    activeItem.setAttribute(
      "aria-selected",
      "true"
    );


    /*
      If the dropdown has become scrollable,
      keep the keyboard-selected result visible.
    */

    activeItem.scrollIntoView({
      block: "nearest"
    });

  }


  /* ==========================================
     GET CURRENT RESULT ELEMENTS
  ========================================== */

  function getPredictiveResultElements() {

    return Array.from(
      dropdown.querySelectorAll(
        ".predictive-search-item"
      )
    );

  }


  /* ==========================================
     MOVE ACTIVE RESULT DOWN
  ========================================== */

  function moveActiveResultDown() {

    const items =
      getPredictiveResultElements();


    if (items.length === 0) {
      return;
    }


    activeIndex += 1;


    if (
      activeIndex >=
      items.length
    ) {

      activeIndex = 0;

    }


    updateActiveResult();

  }


  /* ==========================================
     MOVE ACTIVE RESULT UP
  ========================================== */

  function moveActiveResultUp() {

    const items =
      getPredictiveResultElements();


    if (items.length === 0) {
      return;
    }


    activeIndex -= 1;


    if (
      activeIndex < 0
    ) {

      activeIndex =
        items.length - 1;

    }


    updateActiveResult();

  }


  /* ==========================================
     OPEN ACTIVE RESULT
  ========================================== */

  function openActiveResult() {

    const items =
      getPredictiveResultElements();


    if (
      activeIndex < 0 ||
      activeIndex >= items.length
    ) {

      return false;

    }


    const activeItem =
      items[activeIndex];


    if (!activeItem.href) {
      return false;
    }


    window.location.href =
      activeItem.href;


    return true;

  }


  /* ==========================================
     CLEAR PREDICTIVE RESULTS
  ========================================== */

  function clearPredictiveResults() {

    dropdown.innerHTML = "";

    currentResults = [];

    activeIndex = -1;


    closeDropdown();

  }


  /* ==========================================
     END PART 2 OF 3
     PASTE PART 3 DIRECTLY BELOW THIS
  ========================================== */
    /* ==========================================
     RUN PREDICTIVE SEARCH
  ========================================== */

  async function runPredictiveSearch() {

    const query =
      input.value.trim();


    /*
      Do not search until the visitor has
      entered the minimum number of characters.
    */

    if (
      query.length <
      MINIMUM_CHARACTERS
    ) {

      clearPredictiveResults();

      return;

    }


    /*
      Show a temporary loading message while
      Shopify processes the search.
    */

    renderLoading();


    try {

      const response =
        await searchStore(query);


      /*
        The visitor may have changed the input
        while this request was being processed.

        If so, do not render results belonging
        to the old query.
      */

      if (
        input.value.trim() !==
        query
      ) {

        return;

      }


      renderResults(
        query,
        response.results,
        response.totalCount
      );


    } catch (error) {

      /*
        AbortError is expected when a visitor
        types another character before the
        previous request has completed.
      */

      if (
        error.name ===
        "AbortError"
      ) {

        return;

      }


      console.error(
        "Predictive search failed:",
        error
      );


      /*
        Only show the error if the input still
        contains the query that failed.
      */

      if (
        input.value.trim() ===
        query
      ) {

        dropdown.innerHTML = `
          <div class="predictive-search-status">
            Unable to load search results.
          </div>
        `;


        openDropdown();

      }

    }

  }


  /* ==========================================
     INPUT EVENT + DEBOUNCE
  ========================================== */

  input.addEventListener(
    "input",
    function () {

      /*
        Cancel the existing debounce timer.
      */

      clearTimeout(
        debounceTimer
      );


      const query =
        input.value.trim();


      /*
        If the visitor deletes the query or
        drops below the minimum character
        requirement, close the dropdown.
      */

      if (
        query.length <
        MINIMUM_CHARACTERS
      ) {

        /*
          Cancel any API request currently
          in progress.
        */

        if (requestController) {

          requestController.abort();

          requestController = null;

        }


        clearPredictiveResults();

        return;

      }


      /*
        Wait briefly after the visitor stops
        typing before searching.

        This prevents an API request being
        generated for every individual
        keystroke.
      */

      debounceTimer =
        setTimeout(
          function () {

            runPredictiveSearch();

          },
          DEBOUNCE_DELAY
        );

    }
  );


  /* ==========================================
     KEYBOARD NAVIGATION
  ========================================== */

  input.addEventListener(
    "keydown",
    function (event) {

      /*
        ESCAPE

        Close the dropdown immediately.
      */

      if (
        event.key ===
        "Escape"
      ) {

        clearTimeout(
          debounceTimer
        );


        closeDropdown();

        return;

      }


      /*
        If the dropdown is closed, arrow-key
        navigation has nothing to operate on.
      */

      if (dropdown.hidden) {

        return;

      }


      /*
        DOWN ARROW
      */

      if (
        event.key ===
        "ArrowDown"
      ) {

        event.preventDefault();

        moveActiveResultDown();

        return;

      }


      /*
        UP ARROW
      */

      if (
        event.key ===
        "ArrowUp"
      ) {

        event.preventDefault();

        moveActiveResultUp();

        return;

      }


      /*
        ENTER

        If a predictive result has been
        selected with the arrow keys, open it.

        If nothing is selected, do nothing
        here and allow the normal search form
        to submit to /search?q=...
      */

      if (
        event.key ===
        "Enter" &&
        activeIndex >= 0
      ) {

        const opened =
          openActiveResult();


        if (opened) {

          event.preventDefault();

        }

      }

    }
  );


  /* ==========================================
     MOUSE HOVER ACTIVE STATE
  ========================================== */

  dropdown.addEventListener(
    "mouseover",
    function (event) {

      const item =
        event.target.closest(
          ".predictive-search-item"
        );


      if (!item) {

        return;

      }


      const index =
        Number(
          item.getAttribute(
            "data-predictive-index"
          )
        );


      if (
        Number.isNaN(index)
      ) {

        return;

      }


      activeIndex =
        index;


      updateActiveResult();

    }
  );


  /* ==========================================
     REMOVE ACTIVE STATE WHEN MOUSE LEAVES
  ========================================== */

  dropdown.addEventListener(
    "mouseleave",
    function () {

      /*
        Remove the visual active state.

        Keyboard navigation can begin again
        from the first result afterward.
      */

      activeIndex = -1;

      updateActiveResult();

    }
  );


  /* ==========================================
     CLOSE WHEN CLICKING OUTSIDE SEARCH
  ========================================== */

  document.addEventListener(
    "click",
    function (event) {

      /*
        Do nothing when the click happened
        somewhere inside the search wrapper.
      */

      if (
        wrapper.contains(
          event.target
        )
      ) {

        return;

      }


      closeDropdown();

    }
  );


  /* ==========================================
     REOPEN RESULTS WHEN INPUT IS FOCUSED
  ========================================== */

  input.addEventListener(
    "focus",
    function () {

      const query =
        input.value.trim();


      /*
        If we already have rendered results
        for a sufficiently long query, allow
        the dropdown to reopen immediately.
      */

      if (
        query.length >=
          MINIMUM_CHARACTERS &&
        dropdown.innerHTML.trim() !== ""
      ) {

        openDropdown();

      }

    }
  );


  /* ==========================================
     FORM SUBMISSION
  ========================================== */

  form.addEventListener(
    "submit",
    function () {

      /*
        Cancel any pending predictive-search
        timer before navigating to the complete
        search-results page.

        We intentionally do NOT prevent the
        form submission. The existing Shopify
        search form should continue navigating
        normally to:

        /search?q=SEARCHTERM
      */

      clearTimeout(
        debounceTimer
      );


      if (requestController) {

        requestController.abort();

        requestController = null;

      }


      closeDropdown();

    }
  );


  /* ==========================================
     HANDLE BROWSER BACK/FORWARD CACHE
  ========================================== */

  window.addEventListener(
    "pageshow",
    function () {

      /*
        Browsers may restore the page from
        their back/forward cache.

        Do not leave an old predictive dropdown
        visible when that happens.
      */

      closeDropdown();

    }
  );


  /* ==========================================
     CLEAR DROPDOWN IF INPUT IS EMPTY ON LOAD
  ========================================== */

  if (
    input.value.trim().length <
    MINIMUM_CHARACTERS
  ) {

    clearPredictiveResults();

  }


  /* ==========================================
     PREDICTIVE SEARCH INITIALISED
  ========================================== */

  console.log(
    "Predictive search initialized."
  );

});

/* PREDICTIVE SEARCH CODE IS COMPLETE */